import React, { useContext } from "react";
import { MediaAuthContext } from "../../../store/context/media-auth-context";
import PropTypes from "prop-types";
import { DEFAULT_OPTION } from "./index.content";
import { getTrueClasses } from "../../../helpers";
import Container from "../../common/UI/Container";
import RedirectButton from "./RedirectButton";
import Form from "./Form";
import "./index.scss";

const { title } = DEFAULT_OPTION;

const FormPage = ({ redirectUrl, formOpacity, option, formCalculatedData }) => {
  const {
    auth: { isAuth },
  } = useContext(MediaAuthContext);

  return (
    <div
      className={getTrueClasses("PgESM-FP", option?.customClass)}
      style={{ opacity: formOpacity }}
    >
      <Container mode="standard">
        {isAuth ? (
          <RedirectButton
            redirectUrl={redirectUrl}
            {...option?.redirectButton}
          />
        ) : (
          <div className="PgESM-FP-content">
            <div className="PgESM-FP-T">{option?.title || title}</div>
            <div className="PgESM-FP-formBlock">
              <Form {...formCalculatedData} {...option?.form} />
              <div className="PgESM-FP-agree">
                Al ingresar tu email, aceptas recibir emails de marketing de
                AMZScout
              </div>
            </div>
          </div>
        )}
      </Container>
    </div>
  );
};

FormPage.propTypes = {
  option: PropTypes.object,
  isAuth: PropTypes.bool,
  redirectUrl: PropTypes.string,
  formCalculatedData: PropTypes.object,
};

export default FormPage;
